import { FormattedMessage } from 'react-intl';
import { type PreparationStage } from '../../types';
import { US_VISA_PORTAL_URL } from '../stages';

interface Props {
  stage: PreparationStage;
  onReady: () => void;
}

export default function NextStep({ stage, onReady }: Props) {
  return (
    <div>
      <h3 className="text-lg font-semibold text-slate-900">
        <FormattedMessage id={`preparation.nextStep.title.${stage}`} />
      </h3>
      <p className="mt-4 text-base leading-7 text-slate-600">
        <FormattedMessage id={`preparation.nextStep.body.${stage}`} />
      </p>

      <div className="mt-8 flex flex-wrap items-center gap-3">
        <a
          href={US_VISA_PORTAL_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex w-full items-center justify-center rounded-xl bg-brand-700 px-5 py-3.5 text-sm font-semibold text-white transition hover:bg-brand-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-300 sm:w-auto"
        >
          <FormattedMessage id="preparation.nextStep.portalLink" />
        </a>
        <button
          type="button"
          onClick={onReady}
          className="inline-flex w-full items-center justify-center rounded-xl border border-slate-200 bg-white px-5 py-3.5 text-sm font-semibold text-brand-700 transition hover:border-brand-200 hover:bg-brand-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-300 sm:w-auto"
        >
          <FormattedMessage id="preparation.nextStep.ready" />
        </button>
      </div>
    </div>
  );
}
